import {Heading, HStack, Text, useTheme, VStack} from '@chakra-ui/react'
import isEmpty from 'lodash/isEmpty'
import {ReactNode} from 'react'
import {ServiceColor, ServiceIcon} from '../../utils/sevices'
import ServiceBadge from '../Molecules/ServiceBadge'

interface Props {
  customIcon?: ReactNode
  infoBadge?: {color: ServiceColor; icon: ServiceIcon}
  header: string
  mainText?: string
  smallText?: string
}

const InfoWIcon = ({infoBadge, header, mainText, smallText, customIcon}: Props) => {
  const theme = useTheme()

  return (
    <HStack justify='start' spacing={4} w='full'>
      {customIcon
        ? customIcon
        : !isEmpty(infoBadge) && <ServiceBadge icon={infoBadge!.icon} color={infoBadge!.color} />}
      <VStack align='start' spacing={1}>
        <Text variant='small' color={theme.colors.text.basic}>
          {header}
        </Text>
        <HStack align='end'>
          {!isEmpty(mainText) && (
            <Heading variant='medium' color={theme.colors.text.basic}>
              {mainText}
            </Heading>
          )}
          {!isEmpty(smallText) && (
            <Text variant='small' color={theme.colors.text.basic} pb={1}>
              {smallText}
            </Text>
          )}
        </HStack>
      </VStack>
    </HStack>
  )
}

export default InfoWIcon
